module.exports = __webpack_public_path__ + "img/planIndividual.6dcce7f2.png";